let baseState = () => {
  return {
    translations: [],
    newTranslations: [],
    currentPage: 1,
    totalPageCount: 1,
    totalCount: 0
  }
}

const state = baseState()

export default state
export { baseState }
